import React from "react";
import { Typography } from "@material-ui/core";
import { get } from "lodash";

const CategoryField = ({ source, record, basePath, resource, ...props }) => {
  const categoryName = get(record, "category.description", null);
  const subcategoryName = get(record, "subcategory.description", null);
  const customCategoryName = get(record, source, null);
  const value = [categoryName, subcategoryName, customCategoryName]
    .filter((c) => c !== null)
    .join(" / ");
  return (
    <Typography variant="body2" {...props}>
      {value}
    </Typography>
  );
};
export default CategoryField;
